// extracted by mini-css-extract-plugin
export default {"container":"FuwDevice_container__fj18B","wrapper":"FuwDevice_wrapper__hnFF9","icon":"FuwDevice_icon__6xZ3P","shrink":"FuwDevice_shrink__IF8Pg","title":"FuwDevice_title__UmMsT"};